import Vue from 'vue';
import uuid from '@/libs/uuid'

export default Vue.extend({
  data() {
    return {
      id: undefined,
      data: false, 
      disable: false,
      trueValue: "Y",
      falseValue: "N",
      isSelecBoxShow: false,
      selects: [],
      selectKey: '',
      accessApi: false
    }
  },
  watch: {
    'value': { 
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {

          let tVal;

          if(typeof this.params.colDef.cellRendererParams === 'function') {
            let data = this.params.colDef.cellRendererParams(this.params);
            tVal = data.trueValue;
            this.disable = data.disable;
            this.isSelecBoxShow = data.isSelecBoxShow;
            this.accessApi = data.accessApi;
            this.selectKey = this.params.data.changePayRSKey;
          } else{
            tVal = this.params.colDef.cellRendererParams?.trueValue;
            this.disable = this.params.colDef.cellRendererParams?.disable;
            this.isSelecBoxShow = this.params.colDef.cellRendererParams?.isSelecBoxShow;
            this.accessApi = this.params.colDef.cellRendererParams?.accessApi;
            this.selectKey = this.params.data.changePayRSKey;
          }
          this.data = this.params.value === (tVal || this.trueValue) ? true : false;
          this.$forceUpdate()

          if(this.accessApi) { //API 사용할 때만 호출용.. 여기서 부터는 각자 맞게 호출..
            if(this.data) {
              // this.selects = [{key: '01', value: 'M/A 계약분'}, {key: '02', value: '미방문(접수취소)'}]
              //유상(355)인 경우
              this.$http.get(`/api/codeMng/combo`, {params: {parentId: 355}}) // ChangePayYn
              .then(response => {
                this.selects = response.data || []
              });
            } else {
              //무상(354)인 경우
              this.$http.get(`/api/codeMng/combo`, {params: {parentId: 354}}) // ChangePayYn
                .then(response => {
                  this.selects = response.data || []
                });
            }
          }
        })
      }
    }
  },
  created() {
    this.id = uuid()
  },
  methods: {
    checkedHandler(target) {
      let checked = null
      
      if(typeof this.params.colDef.cellRendererParams === 'function') {
        checked = target ? this.trueValue : this.falseValue;
      } else {
        if(this.params.colDef.cellRendererParams === undefined){        
          checked = target ? this.trueValue : this.falseValue;
        }else{
          
          let fValue = typeof this.params.colDef.cellRendererParams.falseValue === 'boolean' ? false : this.params.colDef.cellRendererParams.falseValue
  
          checked = target ? this.params.colDef.cellRendererParams?.trueValue : fValue
        }
      }
      let colId = this.params.column.colId;
      this.params.node.setDataValue(colId, checked);
      this.selectChanged('');
     

    },
    selectChanged(target) {
      console.log('===js target: ', target)
        //changePayRSKey 사유에 해당 하는 컬럼에 데이터 세팅
        this.params.node.setDataValue('changePayRSKey', target);
    }
  },
    template: 
    `
    <div v-if="isSelecBoxShow">
      <el-form>
        <el-row :gutter="24">
          <el-col :span="9">
            <el-form-item>
              <el-radio-group v-model="data" @change="checkedHandler">
                <el-radio :label="true">유</el-radio>
                <el-radio :label="false">무</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <el-form-item>
              <el-select v-model="selectKey" @change="selectChanged" :disabled="disable">
                <el-option
                    v-for="item in selects"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-else>
      <el-radio-group v-model="data" :disabled="disable" @click="checkedHandler($event)">
        <el-radio :label="true">유</el-radio>
        <el-radio :label="false">무</el-radio>
      </el-radio-group>
    </div>
    `,
});